import { useLocation, useNavigate } from 'react-router-dom';
import { AgnesButton, AgnesPageHeader } from '@agnes/ui';
import { Construction, ArrowLeft } from 'lucide-react';

export default function PageEmConstrucao() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (
    <div className="p-6">
      <AgnesPageHeader title="Módulo em migração" subtitle={pathname} />
      <div className="mt-10 flex flex-col items-center justify-center gap-4 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-agnes-primary-hover">
          <Construction className="h-8 w-8 text-agnes-primary" />
        </div>
        <p className="max-w-sm text-agnes-text-muted">
          Esta tela está sendo migrada para o novo design. Em breve disponível aqui.
        </p>
        <AgnesButton
          variant="secondary"
          startIcon={<ArrowLeft className="h-4 w-4" />}
          onClick={() => navigate('/home')}
        >
          Voltar para a Home
        </AgnesButton>
      </div>
    </div>
  );
}
